import React from 'react'
import tw from 'tailwind-styled-components'

const TwTd = tw.td`
  border
  border-t-0
  border-b-0
  border-l-0
  border-solid
  border-main-old
  first:rounded-l-lg
  last:border-r-0
  last:rounded-r-lg
  leading-6
`

export interface Props {
  children?: React.ReactNode
  className?: string
}

export const Cell = (props: Props) => {
  const {children, className = ''} = props
  return (
    <TwTd valign="top" className={className}>
      {children}
    </TwTd>
  )
}
